module.exports = __webpack_public_path__ + "img/12.383e427d.jpg";